import { Step } from 'signup-constants/Step';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { acq142VariantBPostVerificationSteps } from '../../experiments/gswhV1/gswhUtils';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { FlowStateManager } from '../../flow-management/FlowStateManager';
import { NextStepManager } from '../../flow-management/NextStepManager';
import { shouldAddGoogleContactsSyncStep } from '../../google-contacts-sync/googleContactsSyncUtils';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { setFlow } from '../../store/flow/action-creators';
import { getIsMobile } from '../../utils/deviceUtils';
import { getPostAccountCreationSteps } from '../../store/flow/selectors';
export const BranchGoogleContactsSync = {
  name: 'BranchGoogleContactsSync',
  stateCheck: state => {
    return shouldAddGoogleContactsSyncStep(state) && !getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0143, [ExperimentParameterGroup.Variant_A]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    let nextSteps;
    const isAssignedToVariantA = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0142, [ExperimentParameterGroup.Variant_A]);
    const isAssignedToVariantB = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0142, [ExperimentParameterGroup.Variant_B]);
    if (isAssignedToVariantA) {
      nextSteps = dispatch(FlowStateManager.replaceStep(Step.AhaMoment, Step.AhaMoment, Step.GoogleContactsSync));
    } else if (isAssignedToVariantB) {
      const preVerification = [Step.ProductExperience, Step.ProblemAwareness, Step.UseCase, Step.AhaMoment, Step.LandingPage, Step.CodeVerification];
      const postAccountCreationSteps = getIsMobile() ? [Step.GoogleContactsSync, Step.MobileAppPrompt] : [Step.GoogleContactsSync];
      nextSteps = [Step.CompanyDomain, Step.Industry, Step.CompanySize, Step.ManagementLevel, Step.HubletSelection, ...postAccountCreationSteps];
      dispatch(setFlow(nextSteps, preVerification, acq142VariantBPostVerificationSteps, postAccountCreationSteps, getFlowSteps().postExistingAccountSelection, false));
    } else {
      const flowSteps = getFlowSteps();
      const postAccountCreationSteps = getPostAccountCreationSteps(state);
      const updatedPostAccountCreationSteps = getIsMobile() ? [Step.GoogleContactsSync, ...postAccountCreationSteps, Step.MobileAppPrompt] : [Step.GoogleContactsSync, ...postAccountCreationSteps];
      nextSteps = NextStepManager.addStepsAfterStep(Step.HubletSelection, Step.GoogleContactsSync)(flow);
      dispatch(setFlow(nextSteps, flowSteps.preVerification, flowSteps.postVerification, updatedPostAccountCreationSteps, flowSteps.postExistingAccountSelection));
    }
    return nextSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: Step.CompanyName
};